module.exports = __webpack_public_path__ + "img/slideshow2.0c25c0c6.png";